/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import {declareEntity} from '../fw/MetaDataHelper';
import * as Permission from '../../common/util/Permission';
import {BillingTypes} from './FlowDefType';

export default declareEntity({
    entity: "instanceScenarios",
    graphQL: "InstanceScenario",
    name: "Visible Scenarios",
    dynamoPrefix: 'app',
    storageType: 'central',
    writePermission: [
        Permission.PERM_INSTANCE_ADMIN
    ],
    fields: (types) => { return {
        id: {
            name: "Visible Scenario ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        name: {
            name: "Name",
            userEditable: false,
            filterable: true,
            translatable: true,
            type: "string",
            isPublic: true,
        },
        title: {
            name: "Title",
            userEditable: false,
            filterable: true,
            translatable: true,
            type: "string",
            isPublic: true,
        },
        description: {
            name: "Description",
            userEditable: false,
            translatable: true,
            type: "string",
            isPublic: true,
        },
        longDescription: {
            name: "Long Description",
            userEditable: false,
            translatable: true,
            type: "html",
            isPublic: true,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            parent: true,
            compositeKey: true,
            hiddenCreate: true,
            defaultValue: (parent) => {
                return parent['id'];
            },
        },
        extraPayment: {
            name: "Extra Payment",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        billingType: {
            name: "Billing type",
            isPublic: true,
            type: "enum",
            values: BillingTypes,
        },
        priceInstallation: {
            name: "Installation Price",
            type: "number",
            isPublic: true,
        },
        priceInstallationNext: {
            name: "Installation Price (another)",
            type: "number",
            isPublic: true,
        },
        priceSelfInstallation: {
            name: "Self Installation Price",
            type: "number",
            isPublic: true,
        },
        pricePerInvocation: {
            name: "Price per invocation",
            type: "number",
            isPublic: true,
        },
        pricePerInstance: {
            name: "Price per instance",
            type: "number",
            isPublic: true,
        },
        pricePerInstanceNext: {
            name: "Price per instance (more)",
            type: "number",
            isPublic: true,
        },
        priceText: {
            name: "Price text",
            type: "string",
            description: "Text showed to the user instead of computed text from price parameters. You can use pricePerInstance, pricePerInstanceNext, pricePerInvocation, priceInstallation, invocationName.",
            isPublic: true,
            translatable: true,
        },
        showContactUs: {
            name: "Show Contact Us",
            type: "boolean",
            defaultValue: false,
            isPublic: true,
        },
        scenarioDef: {
            name: "Scenario Definition",
            to: () => types['scenarioDefs'],
            type: "relation",
            required: true,
            hiddenCreate: true,
            defaultValue: (scenario) => {
                return scenario['scenarioDef_id'];
            },
        },
        scenario: {
            name: "Scenario",
            to: () => types['scenarios'],
            type: "relation",
            required: true,
            hiddenCreate: true,
            filterable: true,
            defaultValue: (scenario) => {
                return scenario['id'];
            },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
